import React from 'react'

interface DiamondIconProps {
  size?: 'sm' | 'md' | 'lg'
  glow?: boolean
  className?: string
}

const sizeMap = {
  sm: { width: '8px', height: '8px' },
  md: { width: '12px', height: '12px' },
  lg: { width: '16px', height: '16px' },
}

export const DiamondIcon: React.FC<DiamondIconProps> = ({
  size = 'md',
  glow = true,
  className = '',
}) => {
  const dimensions = sizeMap[size]

  return (
    <span
      className={className}
      style={{
        width: dimensions.width,
        height: dimensions.height,
        background: 'var(--accent)',
        transform: 'rotate(45deg)',
        display: 'inline-block',
        boxShadow: glow ? 'var(--glow-gold)' : 'none',
      }}
    />
  )
}

export default DiamondIcon
